<app-loader [hidden]="(showLoader$ | async) === false" [transparent]="(loaderTransparent$ | async) === true"></app-loader>
<app-progress-bar [hidden]="(showProgressBar$ | async) === false"></app-progress-bar>
<div class="app-toast">
  @for (toast of (toasts$ | async).slice().reverse(); track toast.id) {
    <rc-toast
      [title]="toast?.title"
      [description]="toast?.description"
      [type]="toast?.type"
      isDismissible
      (rc-toast-action)="closeToast(toast?.id)"
      [actions]="toast?.actions"
      [attr.data-qa]="toast?.dataQa"
    ></rc-toast>
  }
</div>
<div class="app-alert">
  @for (alert of (alerts$ | async).slice().reverse(); track alert.id || alert.message) {
    <rc-alert
      (rc-alert-action)="close(alert)"
      [id]="alert?.keyTrad"
      [attr.data-qa]="alert?.dataQa"
      [attr.type]="alert.alertType"
      [type]="alert.alertType"
      [timeout]="alert.alertType === rcAlertType.SUCCESS ? 15 : 0"
      [message]="alert.message"
      [isDismissible]="true"
    ></rc-alert>
  }
</div>
<div [attr.data-version]="version" class="app-body">
  <router-outlet></router-outlet>
</div>
@if (showFooter$ | async) {
  <rc-footer class="app-footer" id="app-footer-panel">
    <ng-container top-right>
      <rc-link
        data-qa="vs-footer-button-back-to-top"
        variant="invert"
        size="large"
        iconname="chevron-up"
        iconposition="left"
        class="app-button"
        (click)="backToTop()"
      >
        {{ 'footer_legal_notice_vs_back' | translateKey }}
      </rc-link>
    </ng-container>
    <ng-container bottom-left>
      <p class="app-version">© Vet Services: {{ version?.version }}</p>
      <a class="app-link" href="https://www.royalcanin.com/fr/mentions-legales/vet" rel="noopener" target="_blank"
        ><span i18n="@@footer_legal_notice_vs_legal">Vet Services legal notice</span></a
      >
    </ng-container>
  </rc-footer>
}

@if (!isStandalone) {
  <div class="cookie-consent" id="cookie-consent">
    <span id="ot-sdk-btn" class="ot-sdk-show-settings">Cookie settings</span>
  </div>
} @else {
  <a [href]="srsTermUrl$ | async" class="rc-link terms" i18n="@@terms_and_conditions" rel="noopener" target="_blank"
    >terms and conditions</a
  >
}
